module.exports = {
  API_URL: process.env.NODE_ENV === 'production' ? 'https://api.positivegrid.com.cn' : 'https://staging-api.positivegrid.com.cn',
  USER_CENTER_URL: process.env.NODE_ENV === 'production' ? 'https://account.positivegrid.com' : 'https://pg-usercenter-staging.herokuapp.com',
  NEW_API_URL: process.env.NODE_ENV === 'production' ? 'https://api.positivegrid.com.cn' : 'https://staging-api.positivegrid.com.cn',
  STRIPE_KEY: process.env.NODE_ENV === 'production' ? 'pk_live_I4icYg26rg5SBi6w9QTmCYdn' : 'pk_test_oXqT6alY1t80lsQzW3ZuglKD'
}



// WEBPACK FOOTER //
// ./src/urls.js